export default class ResponseError extends Error {
	constructor(response, { data = {}, method } = {}) {
		super(data?.message || response.statusText);

		this.name = 'ResponseError';
		this.status = response.status;
		this.data = data;
		this.response = response;
		this.statusText = response.statusText;
		this.method = method;
	}
}
